import { render, staticRenderFns } from "./subscriberAddOrder.vue?vue&type=template&id=bc78c332&scoped=true"
import script from "./subscriberAddOrder.vue?vue&type=script&lang=js"
export * from "./subscriberAddOrder.vue?vue&type=script&lang=js"
import style0 from "./subscriberAddOrder.vue?vue&type=style&index=0&id=bc78c332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc78c332",
  null
  
)

export default component.exports